const WarningIcon = ({ fill = '#D71225' }: { fill?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7.2381 6.30352L7.46429 9.55718H8.53571L8.7619 6.30352L8.82143 5H7.17857L7.2381 6.30352ZM7.28571 11.7434C7.48413 11.9145 7.72222 12 8 12C8.29365 12 8.53175 11.9145 8.71429 11.7434C8.90476 11.5655 9 11.35 9 11.0968C9 10.8368 8.90476 10.6212 8.71429 10.4501C8.53175 10.2791 8.29365 10.1935 8 10.1935C7.72222 10.1935 7.48413 10.2791 7.28571 10.4501C7.09524 10.6212 7 10.8368 7 11.0968C7 11.35 7.09524 11.5655 7.28571 11.7434Z"
        fill={fill}
      />
    </svg>
  );
};

export default WarningIcon;
